import React, { Component } from 'react';
import { Modal, Icon, Button, Table } from 'semantic-ui-react';

class ViewAllocation extends Component {

    render() {
        const { allocation } = this.props;
        return (
            <Modal size="small" open={this.props.open} onClose={this.props.close} closeIcon>
                <Modal.Header>Payment Allocation</Modal.Header>
                <Modal.Content>
                    <Table className="small fluid">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Principal Balance</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.principalBalance, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Principal</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patPrincipalBalance, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Accumulated Interest</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.interest, "0.00") + this.props._ifNull(allocation.accumulatedInterest, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Accumulated Interest</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patInterest, "0.00") + this.props._ifNull(allocation.patAccumulatedInterest, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Other Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.otherCharges, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Other Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patOtherCharges, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Penalty Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.penality, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Penalty Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patPenality, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Court Cost</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.courtCost, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Court Cost</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patCourtCost, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Attorney Fees</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.attorneyFees, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Attorney Fees</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patAttorneyFees, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Agency Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.agencyCharges, "0.00")).toFixed(2)}</Table.Cell>
                                <Table.Cell>Payment to Agency Charges</Table.Cell>
                                <Table.Cell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patAgencyCharges, "0.00")).toFixed(2)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Currency Code</Table.Cell>
                                <Table.Cell className="right aligned"> {allocation.currencyCode}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell><h4>Total (Current):</h4></Table.HeaderCell>
                                <Table.HeaderCell className="right aligned"> {parseFloat(this.props._ifNull(allocation.totalBalance, "0.00") + this.props._ifNull(allocation.patTotalBalance, "0.00")).toFixed(2)}</Table.HeaderCell>
                                <Table.HeaderCell><h4>Total (Paid):</h4></Table.HeaderCell>
                                <Table.HeaderCell className="right aligned"> {parseFloat(this.props._ifNull(allocation.patTotalBalance, "0.00")).toFixed(2)}</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell></Table.HeaderCell>
                                <Table.HeaderCell className="right aligned"></Table.HeaderCell>
                                <Table.HeaderCell><h4>Total (New):</h4></Table.HeaderCell>
                                <Table.HeaderCell className="right aligned"> {parseFloat(this.props._ifNull(allocation.totalBalance, "0.00")).toFixed(2)}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                </Modal.Content>
                <Modal.Actions>
                    <Button.Group width={2} className="small buttons">
                        <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                        <Button.Or />
                        <Button positive onClick={this.props.handleSubmit} disabled={allocation.length > 0}>{this.props.t("submit")}</Button>
                    </Button.Group>
                </Modal.Actions>
            </Modal>
        );
    }
}
export default ViewAllocation;


// WEBPACK FOOTER //
// ./src/app/ui/payments/ViewAllocation.js